import React, { useEffect, useState } from "react";

const prefersReduced = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Typewriter — types a phrase out, pauses, deletes it, then moves to the next,
 * cycling through `words` forever. Under prefers-reduced-motion it just shows
 * the first phrase (no animation, static caret).
 */
export default function Typewriter({
  words,
  typeSpeed = 72,
  deleteSpeed = 38,
  pauseEnd = 1500,
  pauseStart = 420,
  className = "",
}) {
  const [reduced] = useState(prefersReduced);
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (reduced) return undefined;
    const current = words[index % words.length];

    let delay;
    if (!deleting && subIndex === current.length) delay = pauseEnd;
    else if (deleting && subIndex === 0) delay = pauseStart;
    else delay = deleting ? deleteSpeed : typeSpeed;

    const t = setTimeout(() => {
      if (!deleting && subIndex === current.length) {
        setDeleting(true);
      } else if (deleting && subIndex === 0) {
        setDeleting(false);
        setIndex((i) => (i + 1) % words.length);
      } else {
        setSubIndex((s) => s + (deleting ? -1 : 1));
      }
    }, delay);

    return () => clearTimeout(t);
  }, [subIndex, deleting, index, words, reduced, typeSpeed, deleteSpeed, pauseEnd, pauseStart]);

  const current = words[index % words.length];
  const shown = reduced ? current : current.slice(0, subIndex);

  return (
    <span className={className} aria-hidden="true">
      {shown}
      <span className="tw-caret" />
    </span>
  );
}
